<div class="landing-wrapper">
    <div class="landing-card">
        <h1 style="color: rgb(0, 161, 154);">TRA CỨU NGUỒN GỐC SẢN PHẨM</h1>

        <div class="p-4 d-flex flex-column gap-3 align-items-center">
            <div class="w-50 text-center" style="border: 2px solid rgb(0, 161, 154);"></div>
            <h3 class="text-center">Vui lòng nhập thông tin để tra cứu nguồn gốc sản phẩm</h3>
            <h4 class="text-center" style="color: red">Chỉ tra cứu được các sản phẩm thuộc phân phối của Dược Vương </h4>
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="form-group position-relative">
                <label for="productName">Tên Sản Phẩm</label>
                <input id="productName" formControlName="productName" type="text" class="form-control"
                    placeholder="Nhập tên sản phẩm" (keyup)="onInput($event)" />

                <div class="dropdown-list d-block" *ngIf="showSearchResult">
                    <ul>
                        <li *ngFor="let product of filteredProducts">
                            <div style="
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                            ">
                                <div class="w-100" (click)="selectProduct(product)">
                                    {{ product.name }}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="form-group">
                <label for="batch">Số Lô</label>
                <select id="batch" formControlName="batch" class="form-control" (change)="onSelectBatch($event)">
                    <option value="" disabled>Chọn số lô</option>
                    <option *ngFor="let batch of batchList" [value]="batch.name">{{ batch.name }}</option>
                </select>
            </div>

            <div class="form-group">
                <label for="expiredDate">Hạn Sử Dụng</label>
                <select id="expiredDate" formControlName="expiredDate" class="form-control">
                    <option value="" disabled>Chọn hạn Sử Dụng</option>
                    <option *ngFor="let date of expiredDates" [value]="date">{{ date }}</option>
                </select>
            </div>

            <div class="d-flex justify-content-center">
                <button type="submit" class="btn-lookup" [disabled]="isLoading">
                    <span *ngIf="isLoading">Đang tra cứu...</span>
                    <span *ngIf="!isLoading">TRA CỨU</span>
                </button>
            </div>
        </form>

        <div *ngIf="result" class="d-flex justify-content-center mt-4 pt-4 border-top border-2">
            <div class="d-grid gap-3 w-100">
                <h2 class="text-center" style="color: rgb(0, 161, 154);">Kết quả tra cứu</h2>

                <div class="result-card">
                    <h3 class="fw-bold pb-3">Thông tin sản phẩm:</h3>
                    <div class="result-item">
                        Ngày nhập: {{ result.importDate |date: 'dd/MM/yyyy' }}
                    </div>
                    <div class="result-item">
                        Mã PO nhập: {{ result.importPOCode }}
                    </div>
                    <!-- <div class="result-item">
                        Số lượng nhập: {{ result.ImportQuantity }}
                    </div>
                    <div class="result-item">
                        Nhà cung cấp: {{ result.Provider }}
                    </div> -->
                    <h3 class="fw-bold py-3">Các lô khác của sản phẩm:</h3>
                    <div class="d-flex flex-wrap gap-3">
                        <div *ngFor="let item of batchList" class="batch-item" (click)="selectBatchItem(item.name)">
                            {{ item.name}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
